// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Force modal width to 600px */
.subscription-modal .modal-dialog {
  max-width: 600px !important;
  width: 600px !important;
}

.subscription-modal .modal-content {
  width: 100% !important;
}

@media (max-width: 768px) {
  .subscription-modal .modal-dialog {
    max-width: 90% !important;
    width: 90% !important;
    margin: 0.5rem auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionModal/SubscriptionModal.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;EAChC;AACF","sourcesContent":["/* Force modal width to 600px */\n.subscription-modal .modal-dialog {\n  max-width: 600px !important;\n  width: 600px !important;\n}\n\n.subscription-modal .modal-content {\n  width: 100% !important;\n}\n\n@media (max-width: 768px) {\n  .subscription-modal .modal-dialog {\n    max-width: 90% !important;\n    width: 90% !important;\n    margin: 0.5rem auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
